var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaybook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.667,
    height: 14,
    viewBox: "0 0 11.667 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.5 -283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-337.5,283v14h11.667V283Zm10.694,13.028h-9.722V283.972h9.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-332.117,286.655l-.614-.612-1.083,1.079-.361-.36-.614.612.975.973Z",
    transform: "translate(-0.602 -0.676)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.689,
    height: 0.866,
    transform: "translate(-331.858 285.932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-332.117,291.055l-.614-.612-1.083,1.079-.361-.36-.614.612.975.973Z",
    transform: "translate(-0.602 -1.654)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.689,
    height: 0.866,
    transform: "translate(-331.858 289.354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-332.117,295.455l-.614-.612-1.083,1.079-.361-.36-.614.612.975.973Z",
    transform: "translate(-0.602 -2.632)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.689,
    height: 0.866,
    transform: "translate(-331.858 292.777)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaybook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/playbook.f31a271804c0fe2cd612e6024a6fe7a9.svg";